/**
 * GenreMenu.jsx — Genre top-level menu.
 * Genre checkboxes pulled from the GENRES data constant.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownMenuLabel, DropdownMenuCheckboxItem } from '@/components/ui/dropdown-menu';
import { usePW } from '@/lib/store';
import { GENRES } from '@/lib/data';
import { Menu } from './shared';

export function GenreMenu() {
  const { t } = useTranslation();
  const { project, updateProject } = usePW();
  return (
    <Menu label={t('menu.genre')}>
      <DropdownMenuLabel className="text-[11px] uppercase tracking-wider text-muted-foreground">
        {t('menu.commonGenresLabel')}
      </DropdownMenuLabel>
      {GENRES.map(g => (
        <DropdownMenuCheckboxItem
          key={g.id}
          checked={project?.genre === g.id}
          onCheckedChange={() => updateProject({ genre: g.id })}
          className="text-[12.5px]"
        >
          <div className="flex flex-col">
            <span>{g.label}</span>
            <span className="text-[11px] text-muted-foreground">{g.sub}</span>
          </div>
        </DropdownMenuCheckboxItem>
      ))}
    </Menu>
  );
}
